export default __webpack_public_path__ + "static/media/nft8.ebb65540.png";